import { useEffect } from 'react';

export function useOnScrollToTop(
    ref: React.MutableRefObject<HTMLElement | null>
) {
    useEffect(() => {
        if (ref.current)
            ref.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
